<template>
  <v-app-bar app color="white" height="66px" class="appbar">
    <div class="nav-logo clickable" @click="goTo('Home')">
      <CImage :url="logo" :square="false" :alt="'Foncier Public.com'"></CImage>
    </div>
    <v-spacer />
    <div class="nav-btns">
      <v-btn
        class="nav-btn nav-btn-rounded"
        @click="goTo('SearchView')"
        target="_blank"
        color="secondary"
        tile
        depressed
      >
        <span class="mr-2 blue_10--text regular-app-bar">Espace locataire</span>
      </v-btn>
      <v-btn
        class="nav-btn"
        @click="goTo('Proprietaire')"
        target="_blank"
        color="tertiary"
        tile
        depressed
      >
        <span class="mr-2 greekblue_10--text regular-app-bar"
          >Espace propriétaire</span
        >
      </v-btn>
      <v-btn
        class="nav-btn"
        target="_blank"
        color="transparent"
        tile
        depressed
        v-if="!this.haveUser"
      >
        <span
          class="mr-2 grey_10--text regular-app-bar"
          @click="goTo('Connection')"
        >
          Inscription / Connexion
        </span>
        <Icon type="plus-circle" style="color:--var(grey_10); fontSize:21px" />
      </v-btn>
      <v-btn
        class="nav-btn"
        target="_blank"
        color="transparent"
        tile
        depressed
        v-else
      >
        <span class="mr-2 grey_10--text regular-app-bar" @click="logOut">
          Déconnexion
        </span>
        <Icon type="logout" style="color:--var(grey_10); fontSize:21px" />
      </v-btn>
    </div>
  </v-app-bar>
</template>

<style scoped></style>

<script>
import CImage from "@/components/HomeSections/SubComponents/Image";
import { Icon } from "ant-design-vue";
import { mapGetters } from "vuex";

const firebase = require("firebase/app");
require("firebase/auth");

export default {
  components: {
    CImage,
    Icon,
  },
  data: () => ({
    logo: "logo_foncier-public3-cutted.png",
  }),
  methods: {
    goTo(name) {
      this.redirect(name);
    },
    logOut() {
      firebase
        .auth()
        .signOut()
        .catch(function(error) {
          console.log(error);
        });
    },
  },

  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser",
    }),
  },
};
</script>

<style>
.appbar {
  z-index: 1337 !important;
}

.nav-logo {
  margin-left: 35px;
  min-height: 56px;
  min-width: 100px;
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin-right: 1rem;
}

.nav-btns {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  height: 100%;
}

.nav-btn {
  height: 100% !important;
  text-transform: none !important;
}

.nav-btn-rounded {
  border-radius: 0px 0px 0px 48px !important;
}

.v-toolbar__content {
  padding: 0px 0px 0px 16px !important;
}
</style>
